/*
  AYO Duo deal (sections/ayo-duo.liquid).
  Two slots: one product from the first collection and one from the second, each with its size.
  The switch shows one list at a time; picking fills the slot and moves to the other list.
  One tap adds both to the cart (marked with the same _set so a bundle app can pair them).
*/
(function () {
  if (customElements.get('ayo-duo')) return;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (t, o) => String(t || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
  const moneyFmt = (cents, format) => {
    const f = (n, dec, th, ds) => { const [i, d] = (n / 100).toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : ''); };
    return String(format || 'LE {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    }).replace(/[.,]00(?=\D*$)/, '');
  };
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = () => ((window.routes && window.routes.cart_url) || '/cart').replace(/\/cart$/, '');

  class AyoDuo extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-ayo-du-data]');
      if (!raw) return;
      try { this.d = JSON.parse(raw.textContent); } catch (e) { return; }
      this.t = this.d.text;
      this.L = this.d.lists;
      this.deal = parseInt(this.dataset.deal, 10) || 0;
      this.multi = this.dataset.multi !== 'false';
      this.M = (c) => moneyFmt(c, this.d.money);
      this.tab = 0;
      this.pick = [null, null];
      this.done = false;
      this.addEventListener('click', (e) => this.onClick(e));
      const dlg = this.$('[data-ayo-du-size]');
      if (dlg) {
        dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('close', () => document.documentElement.classList.remove('ayo-lock'));
      }
      document.body.classList.add('has-ayo-du-bar');
      const worth = this.$('[data-ayo-du-worth]');
      const max = (l) => l.reduce((a, p) => Math.max(a, p.n), 0);
      const top = max(this.L[0]) + max(this.L[1]);
      if (worth && top > this.deal && this.L[0].length && this.L[1].length) { worth.textContent = fill(worth.textContent, { worth: this.M(top) }); worth.hidden = false; }
      this.paint();
      this.equation();
    }

    disconnectedCallback() { document.body.classList.remove('has-ayo-du-bar'); clearInterval(this.eqT); clearTimeout(this.toastT); }

    $(sel) { return this.querySelector(sel); }
    img(p) { return p && p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="500" height="500">` : ''; }

    equation() {
      const a = this.$('[data-ayo-du-eq="0"]'), b = this.$('[data-ayo-du-eq="1"]');
      if (!a || !b || !this.L[0].length || !this.L[1].length) return;
      let i = 0;
      const show = () => { a.innerHTML = this.img(this.L[0][i % this.L[0].length]); b.innerHTML = this.img(this.L[1][i % this.L[1].length]); i += 1; };
      show();
      if (!reduce() && (this.L[0].length > 1 || this.L[1].length > 1)) this.eqT = setInterval(show, 2600);
    }

    grid() {
      const g = this.$('[data-ayo-du-grid]');
      if (!g) return;
      const cur = this.pick[this.tab];
      g.innerHTML = this.L[this.tab].map((p, i) => {
        const on = cur && cur.p.id === p.id;
        const was = this.d.compare !== false ? `<span class="ayo-du__p"><s>${esc(this.M(p.n))}</s></span>` : '';
        return `<button type="button" class="ayo-du__card ayo-du__glass${on ? ' is-on' : ''}" data-ayo-du-p="${i}" aria-pressed="${!!on}"><span class="ayo-du__pic">${this.img(p)}<span class="ayo-du__ck" aria-hidden="true">✓</span></span><span class="ayo-du__n">${esc(p.t)}</span>${was}</button>`;
      }).join('');
      this.querySelectorAll('[data-ayo-du-tab]').forEach((b) => b.classList.toggle('is-on', +b.dataset.ayoDuTab === this.tab));
      const seg = this.$('[data-ayo-du-seg]'); if (seg) seg.classList.toggle('is-right', this.tab === 1);
    }

    paint() {
      [0, 1].forEach((i) => {
        const x = this.pick[i];
        const slot = this.$(`[data-ayo-du-slot="${i}"]`);
        if (!slot) return;
        slot.classList.toggle('is-full', !!x);
        slot.classList.toggle('is-on', this.tab === i && !x);
        this.$(`[data-ayo-du-spic="${i}"]`).innerHTML = x ? this.img(x.p) : `<b>+</b>${esc(i ? this.t.slotB : this.t.slotA)}`;
        this.$(`[data-ayo-du-sname="${i}"]`).textContent = x ? `${x.p.t}${x.z ? ` · ${x.z}` : ''}` : this.t.empty;
        this.$(`[data-ayo-du-clear="${i}"]`).hidden = !x;
        const ok = this.$(`[data-ayo-du-ok="${i}"]`); if (ok) ok.textContent = x ? ' ✓' : '';
      });
      const n = this.pick.filter(Boolean).length;
      const sum = this.pick.reduce((a, x) => a + (x ? x.price : 0), 0);
      const was = this.$('[data-ayo-du-was]');
      const note = this.$('[data-ayo-du-note]');
      const main = this.$('[data-ayo-du-main]');
      const meter = this.$('[data-ayo-du-meter]'); if (meter) meter.style.width = `${(n / 2) * 100}%`;
      if (this.done && !n) {
        if (was) was.textContent = '';
        if (note) { note.textContent = this.t.added; note.className = 'is-ok'; }
        if (main) { main.textContent = this.t.btnCheckout; main.classList.add('is-ready'); }
      } else if (n === 2) {
        if (was) was.textContent = sum > this.deal ? this.M(sum) : '';
        if (note) { note.textContent = sum > this.deal ? fill(this.t.save, { saved: this.M(sum - this.deal) }) : this.t.same; note.className = 'is-ok'; }
        if (main) { main.textContent = this.t.btnAdd; main.classList.add('is-ready'); }
      } else {
        if (was) was.textContent = '';
        if (note) { note.textContent = n ? (this.pick[0] ? this.t.needB : this.t.needA) : this.t.start; note.className = ''; }
        if (main) { main.textContent = this.pick[0] ? this.t.btnB : this.t.btnA; main.classList.remove('is-ready'); }
      }
      this.grid();
    }

    toast(text, bad) {
      const el = this.$('[data-ayo-du-toast]'); if (!el) return;
      el.textContent = text; el.classList.toggle('is-bad', !!bad); el.hidden = false;
      el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in');
      clearTimeout(this.toastT); this.toastT = setTimeout(() => { el.hidden = true; }, 2200);
    }

    go(tab) {
      this.tab = tab;
      this.paint();
      const seg = this.$('[data-ayo-du-seg]');
      if (seg && seg.getBoundingClientRect().top > window.innerHeight * 0.5) {
        const slots = this.$('.ayo-du__slots');
        (slots || seg).scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
      }
    }

    put(tab, p, vid, z, price) {
      if (this.done && !this.multi) { this.toast(this.t.added); return; }
      this.pick[tab] = { p, vid, z, price };
      this.done = false;
      if (this.pick[0] && this.pick[1]) { this.paint(); this.toast(this.t.ready); return; }
      this.toast(tab ? this.t.pickedB : this.t.pickedA);
      this.tab = this.pick[0] ? 1 : 0;
      this.paint();
    }

    onClick(e) {
      const clear = e.target.closest('[data-ayo-du-clear]');
      if (clear) { e.preventDefault(); e.stopPropagation(); const i = +clear.dataset.ayoDuClear; this.pick[i] = null; this.tab = i; this.paint(); return; }
      const slot = e.target.closest('[data-ayo-du-slot]'); if (slot) { this.go(+slot.dataset.ayoDuSlot); return; }
      const tab = e.target.closest('[data-ayo-du-tab]'); if (tab) { this.tab = +tab.dataset.ayoDuTab; this.paint(); return; }
      const card = e.target.closest('[data-ayo-du-p]');
      if (card) {
        const p = this.L[this.tab][+card.dataset.ayoDuP];
        if (!p) return;
        if (!p.z.length) { this.put(this.tab, p, p.v, '', p.n); return; }
        this.cur = [this.tab, p];
        const dlg = this.$('[data-ayo-du-size]');
        dlg.querySelector('[data-ayo-du-simg]').src = p.i || '';
        dlg.querySelector('[data-ayo-du-stitle]').textContent = p.t;
        dlg.querySelector('[data-ayo-du-sizes]').innerHTML = p.z.map(([z, id]) => `<button type="button" class="ayo-du__size" data-ayo-du-v="${id}">${esc(z)}</button>`).join('');
        if (typeof dlg.showModal === 'function') { dlg.showModal(); document.documentElement.classList.add('ayo-lock'); }
        return;
      }
      const v = e.target.closest('[data-ayo-du-v]');
      if (v) {
        const [tb, p] = this.cur; const id = +v.dataset.ayoDuV; const z = p.z.find((x) => x[1] === id);
        this.$('[data-ayo-du-size]').close();
        this.put(tb, p, id, z ? z[0] : '', z ? z[2] : p.n);
        return;
      }
      if (e.target.closest('[data-ayo-du-close]')) { const dlg = e.target.closest('dialog'); if (dlg) dlg.close(); return; }
      if (e.target.closest('[data-ayo-du-main]')) this.main();
    }

    async main() {
      if (this.done && !this.pick[0] && !this.pick[1]) { window.location.href = this.t.checkoutUrl || '/checkout'; return; }
      if (!this.pick[0] || !this.pick[1]) { this.go(this.pick[0] ? 1 : 0); return; }
      const btn = this.$('[data-ayo-du-main]');
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      const set = `D${Date.now().toString(36)}`;
      const props = { _bundle: 'Duo deal', _set: set };
      const body = { items: this.pick.map((x) => ({ id: x.vid, quantity: 1, properties: props })) };
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map((x) => x.id); body.sections_url = window.location.pathname; }
      try {
        const res = await fetch(`${root()}/cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || '');
        if (cart && data.sections && typeof cart.getSectionsToRender === 'function') {
          cart.classList.remove('is-empty');
          cart.getSectionsToRender().forEach((sec) => {
            const html = data.sections[sec.id]; if (!html) return;
            const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id); if (!el) return;
            const src = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector || '.shopify-section');
            if (src) el.innerHTML = src.innerHTML;
          });
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-duo', cartData: data });
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        this.pick = [null, null];
        this.tab = 0;
        this.done = true;
        this.paint();
        this.toast(this.multi ? this.t.again : this.t.added);
      } catch (err) {
        this.toast(err.message || this.t.error, true);
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }
  customElements.define('ayo-duo', AyoDuo);
})();
